<template>
  <div class="d-flex flex-wrap" v-if="hasRole(roles.RW_REAL_ESTA_ADMIN)">
    <div class="col-md-3">
        <Searchsalesbyaccredited v-on:search="search" v-on:setSearch="setSearch" v-on:setCustomDate="setCustomDate"></Searchsalesbyaccredited>
    </div>
    <div class="col-md-9">
       <div id="card-sales">
            <div v-show="!haveData"  id="img-card-sales">
                <img id="img-card" class="img" src="https://static.zopone.com.br/img/realestate/none-image.png">
            </div>
            <div v-if="hasData" class="containter-has-data">
              <div v-if="onlyTable">
              <TableSalesAccredtitedMonth
                v-for="(report, i) in reportEnterprise"
                :key="i"
                :dataSales="report"
                :columns="columns"
              ></TableSalesAccredtitedMonth>
            </div>

            <div  :key="containerBoards" v-else class="container-boards">
              <div id="board-auto" v-show="haveData" v-for="(mes,i) in meses" :key="mes">
                <BoardSaledReportsAccredited
                    ref="BoardSale"
                    v-if="i <= currentyMonth || customDate"
                    :mes="mes"
                    :posicaoMes="i"
                    :dataSalesProp="filterByMonth(i)"
                    v-on:getDataSales="getDataSales"
                  ></BoardSaledReportsAccredited>
              </div>

            </div>

            </div>

            <div v-else class="container-no-has-data">
              <div :class="containerImgReportClass">
                <img src="https://static.zopone.com.br/img/realestate/ReportNotFound.png" />
              </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Salesbyaccredited from './salesbyaccredited'
export default Salesbyaccredited

</script>

<style scoped>
#card-sales{
  height: 75vh;
  overflow: auto;
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
#img-card-sales{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
#img-card{
  object-fit: cover;
}
img {
  width:  60%;
}

.container-img-reports{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.invisible{
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesbyaccredited/salesbyaccredited.vue